import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  Chat200,
  Chat400,
  Chat500,
  ChatBody,
  ChatStream400,
  ChatStream500,
  ChatStreamBody,
  CreateConversation201,
  CreateConversation400,
  CreateConversation401,
  CreateConversationBody,
  DeleteConversation401,
  DeleteConversation404,
  GetConversation200,
  GetConversation401,
  GetConversation404,
  GetModelStatus200,
  GetModels200Item,
  ListConversations200Item,
  ListConversations401,
  ListConversationsParams,
  UpdateConversation200,
  UpdateConversation400,
  UpdateConversation401,
  UpdateConversation404,
  UpdateConversationBody
} from './types'
import { customInstance } from '../custom-axios';


type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


/**
 * 다양한 AI 모델과 채팅합니다. OpenAI/Gemini, Ollama 등을 지원합니다.
 * @summary AI 채팅
 */
export const chat = (
    chatBody: ChatBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<Chat200>(
      {url: `https://ai.ugot.uk/api/ai/v2/chat`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: chatBody
    },
      options);
    }
  


export const getChatMutationOptions = <TError = Chat400 | Chat500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof chat>>, TError,{data: ChatBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof chat>>, TError,{data: ChatBody}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof chat>>, {data: ChatBody}> = (props) => {
          const {data} = props ?? {};

          return  chat(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ChatMutationResult = NonNullable<Awaited<ReturnType<typeof chat>>>
    export type ChatMutationBody = ChatBody
    export type ChatMutationError = Chat400 | Chat500

    /**
 * @summary AI 채팅
 */
export const useChat = <TError = Chat400 | Chat500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof chat>>, TError,{data: ChatBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof chat>>,
        TError,
        {data: ChatBody},
        TContext
      > => {

      const mutationOptions = getChatMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * 실시간 스트리밍 방식으로 AI 응답을 받습니다.
 * @summary AI 스트리밍 채팅
 */
export const chatStream = (
    chatStreamBody: ChatStreamBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<string>(
      {url: `https://ai.ugot.uk/api/ai/v2/chat/stream`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: chatStreamBody
    },
      options);
    }
  


export const getChatStreamMutationOptions = <TError = ChatStream400 | ChatStream500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof chatStream>>, TError,{data: ChatStreamBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof chatStream>>, TError,{data: ChatStreamBody}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof chatStream>>, {data: ChatStreamBody}> = (props) => {
          const {data} = props ?? {};

          return  chatStream(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ChatStreamMutationResult = NonNullable<Awaited<ReturnType<typeof chatStream>>>
    export type ChatStreamMutationBody = ChatStreamBody
    export type ChatStreamMutationError = ChatStream400 | ChatStream500

    /**
 * @summary AI 스트리밍 채팅
 */
export const useChatStream = <TError = ChatStream400 | ChatStream500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof chatStream>>, TError,{data: ChatStreamBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof chatStream>>,
        TError,
        {data: ChatStreamBody},
        TContext
      > => {

      const mutationOptions = getChatStreamMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * 현재 사용 가능한 모든 AI 모델의 목록을 반환합니다.
 * @summary 사용 가능한 AI 모델 목록
 */
export const getModels = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetModels200Item[]>(
      {url: `https://ai.ugot.uk/api/ai/v2/models`, method: 'GET', signal
    },
      options);
    }
  

export const getGetModelsQueryKey = () => {
    return [`https://ai.ugot.uk/api/ai/v2/models`] as const;
    }

    
export const getGetModelsInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getModels>>, TError = unknown>( options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getModels>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetModelsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getModels>>> = ({ signal }) => getModels(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getModels>>, TError, TData> & { queryKey: QueryKey }
}

export type GetModelsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getModels>>>
export type GetModelsInfiniteQueryError = unknown

/**
 * @summary 사용 가능한 AI 모델 목록
 */
export const useGetModelsInfinite = <TData = Awaited<ReturnType<typeof getModels>>, TError = unknown>(
  options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getModels>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetModelsInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetModelsQueryOptions = <TData = Awaited<ReturnType<typeof getModels>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getModels>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetModelsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getModels>>> = ({ signal }) => getModels(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getModels>>, TError, TData> & { queryKey: QueryKey }
}

export type GetModelsQueryResult = NonNullable<Awaited<ReturnType<typeof getModels>>>
export type GetModelsQueryError = unknown

/**
 * @summary 사용 가능한 AI 모델 목록
 */
export const useGetModels = <TData = Awaited<ReturnType<typeof getModels>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getModels>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetModelsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 각 AI 모델의 현재 상태를 확인합니다.
 * @summary AI 모델 상태 확인
 */
export const getModelStatus = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetModelStatus200>(
      {url: `https://ai.ugot.uk/api/ai/v2/models/status`, method: 'GET', signal
    },
      options);
    }
  

export const getGetModelStatusQueryKey = () => {
    return [`https://ai.ugot.uk/api/ai/v2/models/status`] as const;
    }

    
export const getGetModelStatusInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getModelStatus>>, TError = unknown>( options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getModelStatus>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetModelStatusQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getModelStatus>>> = ({ signal }) => getModelStatus(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getModelStatus>>, TError, TData> & { queryKey: QueryKey }
}

export type GetModelStatusInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getModelStatus>>>
export type GetModelStatusInfiniteQueryError = unknown

/**
 * @summary AI 모델 상태 확인
 */
export const useGetModelStatusInfinite = <TData = Awaited<ReturnType<typeof getModelStatus>>, TError = unknown>(
  options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getModelStatus>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetModelStatusInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetModelStatusQueryOptions = <TData = Awaited<ReturnType<typeof getModelStatus>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getModelStatus>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetModelStatusQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getModelStatus>>> = ({ signal }) => getModelStatus(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getModelStatus>>, TError, TData> & { queryKey: QueryKey }
}

export type GetModelStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getModelStatus>>>
export type GetModelStatusQueryError = unknown

/**
 * @summary AI 모델 상태 확인
 */
export const useGetModelStatus = <TData = Awaited<ReturnType<typeof getModelStatus>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getModelStatus>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetModelStatusQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 최근 수정 순으로 AI 채팅 대화 목록을 반환합니다.
 * @summary 사용자 대화 목록 조회
 */
export const listConversations = (
    params?: ListConversationsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ListConversations200Item[]>(
      {url: `https://ai.ugot.uk/api/ai/conversations`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getListConversationsQueryKey = (params?: ListConversationsParams,) => {
    return [`https://ai.ugot.uk/api/ai/conversations`, ...(params ? [params]: [])] as const;
    }

    
export const getListConversationsInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof listConversations>>, TError = ListConversations401>(params?: ListConversationsParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof listConversations>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListConversationsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listConversations>>> = ({ signal }) => listConversations(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof listConversations>>, TError, TData> & { queryKey: QueryKey }
}

export type ListConversationsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof listConversations>>>
export type ListConversationsInfiniteQueryError = ListConversations401

/**
 * @summary 사용자 대화 목록 조회
 */
export const useListConversationsInfinite = <TData = Awaited<ReturnType<typeof listConversations>>, TError = ListConversations401>(
 params?: ListConversationsParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof listConversations>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getListConversationsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getListConversationsQueryOptions = <TData = Awaited<ReturnType<typeof listConversations>>, TError = ListConversations401>(params?: ListConversationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listConversations>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListConversationsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listConversations>>> = ({ signal }) => listConversations(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listConversations>>, TError, TData> & { queryKey: QueryKey }
}

export type ListConversationsQueryResult = NonNullable<Awaited<ReturnType<typeof listConversations>>>
export type ListConversationsQueryError = ListConversations401

/**
 * @summary 사용자 대화 목록 조회
 */
export const useListConversations = <TData = Awaited<ReturnType<typeof listConversations>>, TError = ListConversations401>(
 params?: ListConversationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listConversations>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getListConversationsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 지정된 모델과 제목으로 새로운 대화를 생성합니다.
 * @summary 새 대화 생성
 */
export const createConversation = (
    createConversationBody?: CreateConversationBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<CreateConversation201>(
      {url: `https://ai.ugot.uk/api/ai/conversations`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createConversationBody
    },
      options);
    }
  


export const getCreateConversationMutationOptions = <TError = CreateConversation400 | CreateConversation401,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createConversation>>, TError,{data: CreateConversationBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createConversation>>, TError,{data: CreateConversationBody}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createConversation>>, {data: CreateConversationBody}> = (props) => {
          const {data} = props ?? {};

          return  createConversation(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateConversationMutationResult = NonNullable<Awaited<ReturnType<typeof createConversation>>>
    export type CreateConversationMutationBody = CreateConversationBody
    export type CreateConversationMutationError = CreateConversation400 | CreateConversation401

    /**
 * @summary 새 대화 생성
 */
export const useCreateConversation = <TError = CreateConversation400 | CreateConversation401,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createConversation>>, TError,{data: CreateConversationBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof createConversation>>,
        TError,
        {data: CreateConversationBody},
        TContext
      > => {

      const mutationOptions = getCreateConversationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * 지정된 대화의 전체 메시지 목록을 포함한 상세 정보를 반환합니다.
 * @summary 대화 상세 조회
 */
export const getConversation = (
    conversationId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetConversation200>(
      {url: `https://ai.ugot.uk/api/ai/conversations/${conversationId}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetConversationQueryKey = (conversationId: string,) => {
    return [`https://ai.ugot.uk/api/ai/conversations/${conversationId}`] as const;
    }

    
export const getGetConversationInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getConversation>>, TError = GetConversation401 | GetConversation404>(conversationId: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getConversation>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConversationQueryKey(conversationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConversation>>> = ({ signal }) => getConversation(conversationId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(conversationId),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getConversation>>, TError, TData> & { queryKey: QueryKey }
}

export type GetConversationInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getConversation>>>
export type GetConversationInfiniteQueryError = GetConversation401 | GetConversation404

/**
 * @summary 대화 상세 조회
 */
export const useGetConversationInfinite = <TData = Awaited<ReturnType<typeof getConversation>>, TError = GetConversation401 | GetConversation404>(
 conversationId: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getConversation>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetConversationInfiniteQueryOptions(conversationId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetConversationQueryOptions = <TData = Awaited<ReturnType<typeof getConversation>>, TError = GetConversation401 | GetConversation404>(conversationId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getConversation>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConversationQueryKey(conversationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConversation>>> = ({ signal }) => getConversation(conversationId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(conversationId),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConversation>>, TError, TData> & { queryKey: QueryKey }
}

export type GetConversationQueryResult = NonNullable<Awaited<ReturnType<typeof getConversation>>>
export type GetConversationQueryError = GetConversation401 | GetConversation404

/**
 * @summary 대화 상세 조회
 */
export const useGetConversation = <TData = Awaited<ReturnType<typeof getConversation>>, TError = GetConversation401 | GetConversation404>(
 conversationId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getConversation>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetConversationQueryOptions(conversationId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 대화 제목을 변경합니다.
 * @summary 대화 정보 수정
 */
export const updateConversation = (
    conversationId: string,
    updateConversationBody: UpdateConversationBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<UpdateConversation200>(
      {url: `https://ai.ugot.uk/api/ai/conversations/${conversationId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateConversationBody
    },
      options);
    }
  


export const getUpdateConversationMutationOptions = <TError = UpdateConversation400 | UpdateConversation401 | UpdateConversation404,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateConversation>>, TError,{conversationId: string;data: UpdateConversationBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateConversation>>, TError,{conversationId: string;data: UpdateConversationBody}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateConversation>>, {conversationId: string;data: UpdateConversationBody}> = (props) => {
          const {conversationId,data} = props ?? {};

          return  updateConversation(conversationId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateConversationMutationResult = NonNullable<Awaited<ReturnType<typeof updateConversation>>>
    export type UpdateConversationMutationBody = UpdateConversationBody
    export type UpdateConversationMutationError = UpdateConversation400 | UpdateConversation401 | UpdateConversation404

    /**
 * @summary 대화 정보 수정
 */
export const useUpdateConversation = <TError = UpdateConversation400 | UpdateConversation401 | UpdateConversation404,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateConversation>>, TError,{conversationId: string;data: UpdateConversationBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof updateConversation>>,
        TError,
        {conversationId: string;data: UpdateConversationBody},
        TContext
      > => {

      const mutationOptions = getUpdateConversationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * 지정된 대화를 삭제합니다.
 * @summary 대화 삭제
 */
export const deleteConversation = (
    conversationId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `https://ai.ugot.uk/api/ai/conversations/${conversationId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteConversationMutationOptions = <TError = DeleteConversation401 | DeleteConversation404,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteConversation>>, TError,{conversationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteConversation>>, TError,{conversationId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteConversation>>, {conversationId: string}> = (props) => {
          const {conversationId} = props ?? {};

          return  deleteConversation(conversationId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteConversationMutationResult = NonNullable<Awaited<ReturnType<typeof deleteConversation>>>
    
    export type DeleteConversationMutationError = DeleteConversation401 | DeleteConversation404

    /**
 * @summary 대화 삭제
 */
export const useDeleteConversation = <TError = DeleteConversation401 | DeleteConversation404,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteConversation>>, TError,{conversationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteConversation>>,
        TError,
        {conversationId: string},
        TContext
      > => {

      const mutationOptions = getDeleteConversationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    